<template lang="html">
  <v-flex
    pa-0
    v-bind="layoutBindings"
  >
    <v-layout ma-0>
      <slot />
      <v-flex
        v-if="showHelpBlock"
        py-0
        ml-2
        shrink
        text-center
        :style="`width:30px; min-width:30px; margin-top:${adjustMargin}px`"
      >
        <SiHelpIcon
          v-if="$attrs.help"
          :help-text="$attrs.help"
          color="grey"
          size="24"
        />
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    applyLayout: Boolean,
    helpSpacing: Boolean,
    inputType: String
  },
  computed: {
    ...mapGetters(['_inputTypes']),
    inputDefaults () {
      return {
        layout: { xs12: true, sm9: true, lg8: true },
        helpMarginAdjust: 16
      }
    },
    showHelpBlock () {
      if (this.helpSpacing) return true
      if (this.$attrs.help) return true
      // if (!this.helpSpacing && !this.$attrs.help) return false
      if (!this._inputTypes[this.inputType]) return false
      return !this._inputTypes[this.inputType].hideHelp
    },
    adjustMargin () {
      if (!this._inputTypes[this.inputType]) return this.inputDefaults.helpMarginAdjust
      return this._inputTypes[this.inputType].helpMarginAdjust || this.inputDefaults.helpMarginAdjust
    },
    layoutBindings () {
      if (!this.applyLayout) return { xs12: true }
      if (!this._inputTypes[this.inputType]) return this.inputDefaults.layout
      if (this._inputTypes[this.inputType].layout === 'default') return this.inputDefaults.layout
      return this._inputTypes[this.inputType].layout || this.inputDefaults.layout
    }
  }
}
</script>

<style lang="css" scoped>

</style>
